<template>
  <v-container fluid class="pa-5">
    <v-layout row wrap align-center mb-3>
      <v-flex md6>
        <h4 class="headline">Listado de operadores</h4>
      </v-flex>
      <v-flex md6 class="text-right">
        <h3>
          Conectados {{ (countNumberStats || []).filter(({ status_id }) => status_id !== 0).length }}
        </h3>
        <h3>
          En espera {{ (countNumberStats || []).filter(({ status_id }) => status_id === 1).length }}
        </h3>
        <h3>
          En llamada {{ (countNumberStats || []).filter(({ status_id }) => status_id === 3).length }}
        </h3>
        <h3>
          Desconectado microsip {{ (usersStats || []).filter(({ status_id, disconnect_reason: { id = 0 } = {} }) => status_id === 0 && Number(id) === 10).length }}
        </h3>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-3 mb-4>
      <v-flex pr-3>
        <v-text-field
          v-model="search"
          color="black"
          placeholder="Buscar..."
          solo />
      </v-flex>
      <v-flex md3 pr-3>
        <v-select
          v-model="statusId"
          :items="statusLists"
          item-text="name"
          item-value="id"
          class="white--text"
          color="grey"
          solo>
        </v-select>
      </v-flex>
      <v-flex md6>
        <v-select
          v-model="callListId"
          :items="callsLists"
          item-text="name"
          item-value="id"
          class="white--text"
          color="grey"
          solo>
        </v-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <table v-if="filteredUsersStats.length">
          <thead>
            <th>
              Agente
            </th>
            <th>
              Campaña
            </th>
            <!-- CHANGE_HERE_VOICEMAIL -->
            <th v-if="newInfra">
              Tiempo
            </th>
            <th>
              Estatus
            </th>
            <th>
              Llamada entrante activa
            </th>
          </thead>
          <tbody>
            <tr v-for="item in filteredUsersStats" :key="`user-${item.user_id}`">
              <td>
                <v-icon class="k-orange-linear-text mr-3" large>
                  fas fa-user
                </v-icon>
                {{ item.full_name }}   
              </td>
              <td>
                {{ getCallListName(item.call_list_id) }}
              </td>
              <!-- CHANGE_HERE_VOICEMAIL -->
              <td v-if="newInfra">
                {{ [1,3,4].includes(parseInt(item.status_id, 10)) ? formatTime(item.last_call) : '-' }}
              </td>
              <td>
                <v-chip v-if="item.status_id === 0" class="white--text red">
                  <v-icon class="pr-2 x-small-icon">fas fa-power-off</v-icon>
                  Desconectado
                  ({{ (item.disconnect_reason || {}).name || '' }})
                </v-chip>
                <v-chip v-else-if="item.status_id === 1" :class="{'white--text': true, 'blue': currentTime - item.last_call < 60, 'purple': currentTime - item.last_call >= 60, 'orange': currentTime - item.last_call > 120 }">
                  <v-icon class="pr-2 x-small-icon">fas fa-clock</v-icon>
                  En espera
                </v-chip>
                <v-chip v-else class="white--text green">
                  <v-icon class="pr-2 x-small-icon">fas fa-phone fa-rotate-90</v-icon>
                  En llamada
                </v-chip>
              </td>
              <td>
                <v-tooltip bottom v-if="!newInfra && (item.status_id === 1 || item.status_id === 3) && (item.receive_incoming_calls || item.incoming_calls)">
                  <v-btn @click="openModalSupervisorInterception(item)" slot="activator" small round icon class="k-orange-linear">
                    <v-icon small>
                      fas fa-headphones
                    </v-icon>
                  </v-btn>
                  <span>
                    Escuchar
                  </span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.status_id !== 0 && (item.receive_incoming_calls || item.incoming_calls)" ml-3>
                  <v-icon slot="activator" small class="incomming-call">
                    fas fa-phone fa-rotate-90
                  </v-icon>
                  Llamadas entrantes activas
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
        <v-list
          v-else
          two-line
          class="elevation-1 py-0">
          <v-list-tile
            class="py-1 text-xs-center no-rows">
            <v-icon class="mr-4">
              fas fa-exclamation-circle
            </v-icon>
            <h4>
              No hay nada que mostrar
            </h4>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <modal-supervisor-interception
      :show="showModalSupervisorInterception"
      :disable-save-btn="false"
      :call="selectedCall"
      @save="initSupervisorInterception"
      @close="showModalSupervisorInterception = false"/>
  </v-container>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';
import ModalSupervisorInterception from './ModalSupervisorInterception.vue';

const routerHandler = (to, from, next) => {
  const callListPromise = Vue.axios.get('/calls_lists', {
    params: {
      paginate: 0,
      status: [1],
    },
  })
  .then(({ data }) => data)
  .catch(() => ([]));

  const usersPromise = Vue.axios.get('/call_center/users_v2', {
    params: {
      company_id: Vue.auth.user().company_id,
    },
  })
  .then(({ data: users }) => ({ newInfra: true, users }))
  .catch(() => ({ newInfra: true, users: [] }));

  Promise.all([callListPromise, usersPromise])
    .then(([ callsLists, { newInfra, users } ]) => {
      next((vm) => {
        vm.callsLists = [
          ...vm.callsLists,
          ...callsLists,
        ];
        vm.usersStats = users.map(item => ({
          ...item,
          last_call: item.last_call ||  moment.utc().unix(),
        }));
        vm.newInfra = newInfra;
      });
    });
};

export default {
  components: {
    ModalSupervisorInterception,
  },
  beforeRouteEnter: routerHandler,
  beforeRouteUpdate: routerHandler,
  created() {
    this.componentInterval = setInterval(() => {this.currentTime = moment.utc().unix()}, 1000);
    window.Echo.private(`callList.${this.$auth.user().company_id}.admin`)
      .listen('.CallCenterStatusUpdated', (event) => {
        const index = this.usersStats.findIndex(item => parseInt(item.user_id,10) === parseInt(event.user_id, 10));
        if (index !== -1) {
          Vue.set(this.usersStats, index, {
            ...this.usersStats[index],
            ...event,
            last_call: moment.utc().unix(),
          });
        } else {
          this.usersStats.push({
            ...event,
            last_call: moment.utc().unix(),
          });
        }
      });
  },
  destroyed() {
    window.Echo.leave(`callList.${this.$auth.user().company_id}.admin`);
    clearInterval(this.componentInterval);
  },
  data() {
    return {
      search: '',
      callListId: '',
      statusId: 'connected',
      // CHANGE_HERE_VOICEMAIL
      newInfra: false,
      statusLists: [
        {
          id: '',
          name: 'Estatus',
        },
        {
          id: 'connected',
          name: 'Conectados',
        },
        {
          id: 0,
          name: 'Desconectado',
        },
        {
          id: 1,
          name: 'En espera',
        },
        {
          id: 3,
          name: 'En llamada',
        },
      ],
      callsLists: [
        {
          id: '',
          name: 'Campaña',
        },
      ],
      usersStats: [],
      showModalSupervisorInterception: false,
      selectedCall: {},
      componentInterval:{},
      currentTime: moment.utc().unix(),
    };
  },
  computed: {
    filteredUsersStats() {
      return _.orderBy(
        this.usersStats.filter((item) => {
          let result = true;
          if (this.callListId) {
            result = item.call_list_id === this.callListId;
          }
          if (this.statusId === 'connected') {
            result = result && item.status_id !== 0;
          } else if (this.statusId !== '') {
            result = result && item.status_id === this.statusId;
          }
          if (this.search) {
            result = result && item.full_name.toLowerCase().includes(this.search.toLowerCase());
          }
          return result;
        }).map((item) => {
          if (item.status_id === 0 && Number((item.disconnect_reason || {}).id) === 10) {
            item.order_status_id = 1;
          } else if (item.status_id === 0) {
            item.order_status_id = 4;
          } else if (item.status_id === 1) {
            item.order_status_id = 2;
          } else if (item.status_id === 3) {
            item.order_status_id = 3;
          }
          return item;
        }),
        ['order_status_id', 'last_call'],
        ['asc', 'asc'],
      );
    },
    countNumberStats() {
      return this.usersStats.filter((item) => {
        let result = true;
        if (this.callListId) {
          result = item.call_list_id === this.callListId;
        }
        return result;
      });
    },
  },
  methods: {
    getCallListName(callListId) {
      return (this.callsLists.find(item => item.id === callListId) || {}).name || '';
    },
    joinZoom(conferenceId) {
      window.open(conferenceId, '_blank');
    },
    openModalSupervisorInterception(item) {
      this.selectedCall = item;
      this.showModalSupervisorInterception = !this.showModalSupervisorInterception;
    },
    initSupervisorInterception(form) {
      const body = {
        extension_number: form.extension_number,
        colekter_extension: form.colekter_extension,
      }

      this.$store.dispatch('dialer/startSpyCall', body)
    },
    formatTime(last_call) {
      if (!last_call) {
        return 'No last call'
      }
      return moment.utc((this.currentTime - last_call) * 1000).format('HH:mm:ss');
    }
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
}
table {
  width: 100%;
  border-collapse: collapse;
}
table thead th {
  background: #fff;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid #ff7c64;
}
table thead th:first-child {
  text-align: left;
  padding-left: 15px;
}
table tbody td:first-child {
  padding-left: 15px;
}
table tbody td {
  background: #fff;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ddd;
}
table tbody td:not(:first-child) {
  text-align: center;
}
.incomming-call {
  color: #62d26f !important;
}
</style>


// WEBPACK FOOTER //
// src/components/CallCenter/Users.vue